module.exports = __webpack_public_path__ + "img/phone-orange.2006a837.svg";